import { Injectable } from '@angular/core';
import { HttpWrapperService } from '../http-wrapper.service';
import { map, Observable } from 'rxjs';
import { IHttpRequestOptions } from '../../interfaces/http-request-option.interface';
import { IStoryModel } from '../../interfaces/story.interface';
import { HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class StoryPlaquesService {
  constructor(private httpWrapperService: HttpWrapperService) {}

  GetStoryDetails(plaqueId: number): Observable<IStoryModel> {
    const url = `Story/${plaqueId}`;
    const options: IHttpRequestOptions = {
      url: url,
    };

    return this.httpWrapperService
      .getFromApiGateWay(options)
      .pipe(map((response: IStoryModel) => ({ ...response, plaqueId })));
  }

  attachItemToPlaque(plaqueId: number, itemId: number): Observable<boolean> {
    const url = `story/link/${plaqueId}/${itemId}`;
    const options: IHttpRequestOptions = {
      url: url,
    };
    return this.httpWrapperService
      .postFromApiGateWay(options)
      .pipe(map((response: boolean) => response));
  }

  SaveStoryDetails(
    plaqueId: number,
    storyDetails: IStoryModel,
  ): Observable<boolean> {
    const url = `Story/${plaqueId}`;
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const options: IHttpRequestOptions = {
      url: url,
      headers: headers,
      body: storyDetails,
    };
    return this.httpWrapperService
      .postFromApiGateWay(options)
      .pipe(map((response: boolean) => response));
  }

  //#region Story Media
  getStoryMedia(plaqueId: number): Observable<any> {
    const url = `StoryMedia/${plaqueId}`;
    const options: IHttpRequestOptions = {
      url: url,
    };

    return this.httpWrapperService.getFromApiGateWay(options);
  }

  saveStoryMedia(plaqueId: number, media: any): Observable<boolean> {
    const url = `StoryMedia/${plaqueId}`;
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const options: IHttpRequestOptions = {
      url: url,
      headers: headers,
      body: { blobUrl: media },
    };
    return this.httpWrapperService
      .postFromApiGateWay(options)
      .pipe(map((response: boolean) => response));
  }
  
  copyToTemp(media: any): Observable<any> {
    const url = `StoryMedia/copy/temp`;
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const options: IHttpRequestOptions = {
      url: url,
      headers: headers,
      body: { blobUrl: media },
    };
    return this.httpWrapperService
      .postFromApiGateWay(options)
      .pipe(map((response: boolean) => response));
  }
  
  deleteMedia(id: string): Observable<boolean> {
    const url = `StoryMedia/${id}`;
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const options: IHttpRequestOptions = {
      url: url,
      headers: headers,
    };
    return this.httpWrapperService
      .deleteFromApiGateWay(options)
      .pipe(map((response: boolean) => response));
  }
  //#endregion
}
